/**
 * MUI theme in the phage.energy style (TZ-UI «Правила»): Onest, navy text
 * #04285D, sky accent #09A9F9, white cards on a pale ground, one light theme,
 * no dark panel and no orange. The screens themselves are styled by
 * `components/phage.css`; the theme keeps MUI parts (CssBaseline, any MUI
 * control) in the same colours.
 */
import { createTheme } from '@mui/material/styles';

const NAVY = '#04285D';
const SKY = '#09A9F9';
const SLATE = '#66788f';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: NAVY, dark: '#021A40', light: '#1d4078', contrastText: '#ffffff' },
    secondary: { main: SKY, dark: '#077fc0', light: '#52c1fb', contrastText: '#ffffff' },
    warning: { main: '#b45309' },
    error: { main: '#b42318' },
    info: { main: SKY },
    background: { default: '#f5f9fd', paper: '#ffffff' },
    text: { primary: NAVY, secondary: SLATE, disabled: '#8294ae' },
    divider: '#e3ecf5',
  },
  typography: {
    fontFamily: '"Onest", "Segoe UI", system-ui, -apple-system, Arial, sans-serif',
    fontSize: 14,
    button: { textTransform: 'none', fontWeight: 500 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 50, boxShadow: 'none' } },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { backgroundImage: 'none' }, outlined: { borderColor: '#e3ecf5' } },
    },
    MuiCard: {
      defaultProps: { variant: 'outlined' },
      styleOverrides: { root: { borderRadius: 12, borderColor: '#e3ecf5' } },
    },
    MuiTableCell: { styleOverrides: { body: { fontVariantNumeric: 'tabular-nums' } } },
  },
});
